import { recipe } from '@vanilla-extract/recipes';
import { style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';
import { reducedMotion } from '../../theme/media';

export const track = recipe({
  base: {
    borderRadius: '4px',
    overflow: 'hidden',
  },
  variants: {
    variant: {
      full: {
        flex: 1,
        height: '8px',
        background: vars.surface.card.default,
      },
      mini: {
        flex: 1,
        height: '6px',
        background: vars.opacityScale.whiteOverlay.ultraFaint,
        borderRadius: '3px',
      },
    },
  },
  defaultVariants: {
    variant: 'full',
  },
});

export const fill = recipe({
  base: {
    height: '100%',
    transition: `width ${vars.animation.duration.normal} ${vars.animation.easing.easeOut}`,
    '@media': {
      [reducedMotion]: {
        transition: 'none',
      },
    },
  },
  variants: {
    variant: {
      full: {
        background: `linear-gradient(90deg, ${vars.bright.primary.dark} 0%, ${vars.bright.primary.default} 100%)`,
        borderRadius: '4px',
        boxShadow: vars.bright.borderGlow.default,
      },
      mini: {
        background: vars.bright.primary.default,
        borderRadius: '2px',
      },
    },
  },
  defaultVariants: {
    variant: 'full',
  },
});

export const text = style({
  fontSize: vars.typography.fontSize.sm,
  color: vars.typography.textColor.secondary,
  flexShrink: 0,
  whiteSpace: 'nowrap',
});
